import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router";
import Navbar from "../components/Navbar";
import "./styles/EventLayout.css";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import PersonIcon from "@mui/icons-material/Person";

import Footer from "../sections/Footer.jsx";
import { useModal } from "../contexts/ModalContext";
import { displayEventDate, displayEventTime } from "../utils/datetime";
import {
  AccessTime,
  CalendarMonthOutlined,
  GroupOutlined,
  PinDrop,
} from "@mui/icons-material";
import { ThreeCircles } from "react-loader-spinner";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { updateFavourites } from "../api/UserAPI.js";
import { useAuth } from "../contexts/AuthContext.js";
import { getEventById, getEventImages } from "../api/EventsAPI.js";

export default function Event() {
  //EVENT PAGE
  const { user } = useAuth();
  let params = useParams();
  const [searchParams] = useSearchParams();
  const open = searchParams.get("open");
  const { openModal } = useModal();
  const [selectedTab, setSelectedTab] = useState("overview");
  const [eventDetails, seteventDetails] = useState();
  const [eventImages, seteventImages] = useState([]);
  const [userFavourites, setuserFavourites] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [fullscreenImages, setfullscreenImages] = useState(false);
  const [eventSoldOut, seteventSoldOut] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      const userFavourutes = userData.favourites || [];
      setuserFavourites(userFavourutes);
    }
    initEvent();
  }, []);

  useEffect(() => {
    if (eventDetails) {
      if (open === "register") {
        openModal("checkout", {
          eventData: eventDetails,
          eventId: params.eventId,
        });
      }
    }
  }, [eventDetails]);

  async function initEvent() {
    setisLoading(true);
    const res = await getEventById(params.eventId);
    if (res.success) {
      if (eventSoldOut === false && res.eventData?.ticketOptions) { //TODO multiple ticket types config (not configured)
        const ticketsAvailable = res.eventData?.ticketOptions[0].numAvailable
        const ticketsReserved = res.eventData?.numReserved
        if (ticketsReserved >= ticketsAvailable) {
          seteventSoldOut(true)
        }
      }
      seteventDetails(res.eventData)
      const imageUrlsRes = await getEventImages(params.eventId);
      if (imageUrlsRes.success) {
        const eventImagesWithoutCoverImage = [];
        const coverImage = [];
        const coverImageTitle = res.eventData?.coverImage;
        imageUrlsRes.imageUrls.forEach((url) => {
          if (url?.includes(coverImageTitle)) {
            coverImage.push(url);
          } else {
            eventImagesWithoutCoverImage.push(url);
          }
        });
        seteventImages([...coverImage, ...eventImagesWithoutCoverImage]);
        // console.log('Fetched images:', imageUrlsRes.imageUrls);
      } else {
        console.log("No images found");
      }
    } else {
      console.log("No such document!");
    }
    setisLoading(false);
  }

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check this out!",
          text: "I found this awesome content!",
          url: window.location.href,
        });
      } catch (error) {
        console.log("Error sharing:", error);
      }
    } else {
      alert("Sharing is not supported on this device.");
    }
  };

  async function heartClicked() {
    if (!user) {
      openModal("login");
      return;
    }
    const add = !userFavourites?.includes(params.eventId);
    const res = await updateFavourites(user.uid, params.eventId, add);
    if (res.success) {
      if (res.added) {
        setuserFavourites((prev) => [...prev, params.eventId]);
        const userData = JSON.parse(localStorage.getItem("userData"));
        userData.favourites.push(params.eventId);
        localStorage.setItem("userData", JSON.stringify(userData));
      } else {
        setuserFavourites((prev) =>
          prev.filter((item) => item !== params.eventId)
        );
        const userData = JSON.parse(localStorage.getItem("userData"));
        userData.favourites = userData.favourites.filter(
          (item) => item !== params.eventId
        );
        localStorage.setItem("userData", JSON.stringify(userData));
      }
    }
  }

  const [currentImageDisplayedIndex, setcurrentImageDisplayedIndex] = useState(0);
  const [carouselSlideDirection, setcarouselSlideDirection] = useState("");
  function carouselNavClicked(direction) {
    setcarouselSlideDirection(direction);
    // setTimeout(() => {
      setisLoading(true)
      if (direction === "right") {
        setcurrentImageDisplayedIndex((prev) => {
          if (prev === eventImages.length - 1) {
            return 0;
          } else {
            return prev + 1;
          }
        });
      } else {
        setcurrentImageDisplayedIndex((prev) => {
          if (prev === 0) {
            return eventImages.length - 1;
          } else {
            return prev - 1;
          }
        });
      }
      setcarouselSlideDirection("");

    setTimeout(() => {
      setisLoading(false)
    }, 300); //animation time (DEV return to 500)


    // }, 0); //animation time (DEV return to 500)
  }

  const renderCarouselImages = () => {
    // (DEV return to carousel comp)
    // const renderedImages = [];
    // if (currentImageDisplayedIndex === 0) {
    //   renderedImages.push(eventImages[eventImages.length - 1]);
    //   renderedImages.push(eventImages[currentImageDisplayedIndex]);
    //   renderedImages.push(eventImages[currentImageDisplayedIndex + 1]);
    // } else if (currentImageDisplayedIndex === eventImages.length - 1) {
    //   renderedImages.push(eventImages[currentImageDisplayedIndex - 1]);
    //   renderedImages.push(eventImages[currentImageDisplayedIndex]);
    //   renderedImages.push(eventImages[0]);
    // } else {
    //   renderedImages.push(eventImages[currentImageDisplayedIndex - 1]);
    //   renderedImages.push(eventImages[currentImageDisplayedIndex]);
    //   renderedImages.push(eventImages[currentImageDisplayedIndex + 1]);
    // }
    // return renderedImages.map((url, index) => (
    //   //translateX(-714px) to allow left lside animation
    //   <div
    //     style={{ transform: fullscreenImages ? "" : "translateX(-714px)" }}
    //     className={"image-container image-slide-" + carouselSlideDirection}
    //     key={index}
    //   >
    //     <img src={url} alt={`Event image ${index}`} />
    //   </div>
    // ));

    return (<div
      // style={{ transform: fullscreenImages ? "" : "translateX(-714px)" }}
      className={"image-container image-slide-" + carouselSlideDirection}
    >
      <img src={eventImages[currentImageDisplayedIndex]} alt={`Event image ${1}`} />
    </div>)
  };

  function calculateTicketValues(ticketOptions) {
    let maxPrice = 0;
    let minPrice = -1;
    let spotsAvailable = 0;
    ticketOptions.forEach((option) => {
      const { price, numAvailable } = option;
      if (price > maxPrice) {
        maxPrice = price;
      }
      if (minPrice === -1 || price < minPrice) {
        minPrice = price;
      }
      spotsAvailable = spotsAvailable + numAvailable;
    });
    return { maxPrice, minPrice, spotsAvailable };
  }

  const title = eventDetails?.title || "undefined";
  const infoHeader = eventDetails?.info?.header || "undefined";
  const infoParagraph = eventDetails?.info?.paragraph || "undefined";
  const infoParagraph2 = eventDetails?.info?.paragraph2 || "";
  const type = eventDetails?.type || "undefined";
  const locationName = eventDetails?.location?.name || "undefined";
  const locationAddress = eventDetails?.location?.address || "undefined";
  const overviewDetails = eventDetails?.details || null;
  const hostName = eventDetails?.host?.name || "undefined";
  const hostPhoto = eventDetails?.host?.photoURL || "undefined";
  const hostCreatedAt = eventDetails?.host?.createdAt || "undefined";

  const { maxPrice, minPrice, spotsAvailable } = calculateTicketValues(
    eventDetails?.ticketOptions || []
  );

  async function registerButtonClicked() {
    if (user) {
      openModal("checkout", {
        eventData: eventDetails,
        eventId: params.eventId,
      });
    } else {
      openModal("login");
    }
  }

  const capitalizeFirstChar = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <div className="event-layout">
      <Navbar pageOn={"event"} />
      <div className="event-main">
        <div className="event-top">
          <div className="event-top-left">
            <div className="event-type">
              <p>{type}</p>
            </div>
            <h1>{title}</h1>
            <div className="date-time">
              <div className="date">
                <CalendarMonthOutlined sx={{ color: "gray" }} />
                {displayEventDate(eventDetails)}
              </div>
              <div className="time">
                <AccessTime sx={{ color: "gray" }} />
                {displayEventTime(eventDetails)}
              </div>
            </div>
          </div>
          <div className="event-top-right">
            <button onClick={() => heartClicked()} className="event-action-button">
              {userFavourites?.includes(params.eventId) ?
                <FavoriteIcon sx={{ color: "#ee4d79" }} />
                : <FavoriteBorderIcon sx={{ color: 'black' }} />}
              {/* <FavoriteBorderIcon /> */}
            </button>

            <button onClick={handleShare} className="event-action-button">
              <ShareIcon />
            </button>

            <button style={{ backgroundColor: eventSoldOut ? '#c0cbc1' : 'var(--color-primary)' }}
              className="event-join-button" onClick={() => registerButtonClicked()}>
              <p>{eventSoldOut ? "Sold Out" : "Register Now"}</p>
            </button>
          </div>
        </div>
        <div className="event-container">
          <div className="event-content">
            {/* Image carousel */}
            <div className="media">

              <button onClick={() => carouselNavClicked('left')} className="image-nav-button" style={{ left: '0' }}>
                <KeyboardArrowLeftIcon className="arrow-icon" />
              </button>

              {isLoading ? <div className="loading-spinner-container">
                <ThreeCircles
                  visible={true}
                  width={50}
                  height={50}
                  color="var(--color-primary)"
                  ariaLabel="three-circles-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
                :
                renderCarouselImages()
              }
              <button
                onClick={() => carouselNavClicked("right")}
                className="image-nav-button"
                style={{ right: "0" }}
              >
                <KeyboardArrowRightIcon className="arrow-icon" />
              </button>
              {/* <button
                className="fullscreen-button"
                onClick={() => setfullscreenImages(true)}
              >
                <FullscreenIcon sx={{ color: "white", fontSize: "30px" }} />
              </button> */}
            </div>
            {fullscreenImages && (
              <div className="media-fullscreen">
                <button
                  className="close-button"
                  onClick={() => setfullscreenImages(false)}
                >
                  <CloseIcon sx={{ color: "white", fontSize: "30px" }} />
                </button>
                <button
                  onClick={() => carouselNavClicked("left")}
                  className="image-nav-button"
                  style={{ left: "0" }}
                >
                  <KeyboardArrowLeftIcon className="arrow-icon" />
                </button>
                {isLoading ? (
                  <div className="loading-spinner-container">
                    <ThreeCircles
                      visible={true}
                      width={50}
                      height={50}
                      color="var(--color-primary)"
                      ariaLabel="three-circles-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                ) : (
                  renderCarouselImages()
                )}
                <button
                  onClick={() => carouselNavClicked("right")}
                  className="image-nav-button"
                  style={{ right: "0" }}
                >
                  <KeyboardArrowRightIcon className="arrow-icon" />
                </button>
              </div>
            )}
            <div className="event-details">
              {/* Chrome-style tabs */}
              <div className="chrome-tabs">
                <div
                  className={`chrome-tab ${selectedTab === "overview" ? "active" : ""
                    }`}
                  onClick={() => setSelectedTab("overview")}
                >
                  <span>Overview</span>
                </div>
                <div
                  className={`chrome-tab ${selectedTab === "details" ? "active" : ""
                    }`}
                  onClick={() => setSelectedTab("details")}
                >
                  <span>Details</span>
                </div>
              </div>
              {/* Tab content with background */}
              <div className="tab-content-container">
                <div className="tab-content">
                  {selectedTab === "overview" ? (
                    <>
                      <h2>{infoHeader}</h2>
                      <p>{infoParagraph}</p>
                      <p>{infoParagraph2}</p>
                    </>
                  ) : (
                    <>
                      <h2>Event Details</h2>
                      <p>
                        <strong>Date: </strong>
                        {displayEventDate(eventDetails)}
                      </p>
                      <p>
                        <strong>Time: </strong>
                        {displayEventTime(eventDetails)}
                      </p>
                      <p>
                        <strong>Location: </strong>
                        {locationName}
                      </p>
                      <p>
                        <strong>Address: </strong>
                        {locationAddress}
                      </p>
                      {overviewDetails &&
                        Object.keys(overviewDetails).map((detailKey, index) => (
                          <p key={index}>
                            <strong>{capitalizeFirstChar(detailKey)}: </strong>
                            {overviewDetails[detailKey]}
                          </p>
                        ))}
                      <p>
                        <strong>Organiser: </strong> {hostName}
                      </p>
                      {/* <p><strong>Players:</strong> todo-324</p> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="event-pricing">
            <h1>Registration</h1>
            <p>Secure your spot for this event</p>
            <div className="pricing">
              <p>Standard Entry</p>
              {minPrice === maxPrice ? (
                <h2>{"R" + minPrice}</h2>
              ) : (
                <h2>{"R" + minPrice + " - R" + maxPrice}</h2>
              )}
            </div>
            <div className="details">
              <div className="detail">
                <CalendarMonthOutlined />
                {displayEventDate(eventDetails)}
              </div>
              <div className="detail">
                <PinDrop />
                {locationName}
              </div>
              <div className="detail">
                <GroupOutlined />
                {"Limited to " + spotsAvailable + " participants"} {/*TODO*/}
              </div>
              <div className="register-block">
                <button style={{ backgroundColor: eventSoldOut ? '#c0cbc1' : 'var(--color-primary)' }} onClick={() => registerButtonClicked()}>{eventSoldOut ? "Sold Out" : "Register Now"}</button>
                {/* <p>{"Only " + spotsAvailable + " spots remaining"}</p> */}
              </div>
              <div className="organizer-block">
                <div className="organizer-container">
                  {hostPhoto ? (
                    <img
                      src={hostPhoto}
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "100px",
                      }}
                      alt="Organizer"
                      className="organizer-photo"
                    />
                  ) : (
                    <PersonIcon
                      sx={{ fontSize: "24px", color: "white" }}
                      className="organizer-icon"
                    />
                  )}
                  <p>
                    Organised by{" "}
                    <span className="organizer-name">{hostName}</span>{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer pageOn={"event"} />
    </div>
  );
}
